import React from 'react';
import { Seo } from '../components/Seo';
import { site } from '../config/site';

const faqs = [
  {
    q: 'LuckyBetFR, c’est un bookmaker ?',
    a: 'Non. LuckyBetFR est un site d’information et de comparaison. On n’encaisse pas d’argent, on ne propose pas de paris.',
  },
  {
    q: 'Pourquoi parler autant des retraits ?',
    a: 'Parce que c’est là que se joue la confiance. Une interface peut être jolie, mais si la sortie est floue, tu perds en sérénité.',
  },
  {
    q: 'Les bonus sont-ils toujours une bonne idée ?',
    a: 'Pas automatiquement. Un bonus intéressant est surtout un bonus simple: conditions lisibles, contraintes raisonnables, et cohérence avec ton style de jeu.',
  },
  {
    q: 'KYC: c’est obligatoire ?',
    a: 'Dans la pratique, oui: vérification d’identité (KYC) = sécurité et conformité. Le faire tôt évite les blocages au moment d’un retrait.',
  },
  {
    q: 'Comment choisir vite entre deux offres ?',
    a: 'Commence par la vitesse de retrait et les méthodes disponibles, puis vérifie le turnover du bonus. Ensuite seulement, compare la note et le ressenti UI.',
  },
  {
    q: 'Vous garantissez des gains ?',
    a: 'Non. Les paris sportifs comportent des risques financiers. On aide à choisir une offre, pas à “gagner à coup sûr”.',
  },
] as const;

export default function FaqPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((x) => ({
      '@type': 'Question',
      name: x.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: x.a,
      },
    })),
  };

  return (
    <>
      <Seo
        title="FAQ"
        description="Questions fréquentes sur les offres de paris sportifs en France: bonus, retraits, KYC, sécurité et choix d’un opérateur."
        canonicalPath="/faq"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">FAQ</h1>
        <p className="mt-4 max-w-3xl text-sm text-zinc-200/85">
          Les réponses ci-dessous sont conçues pour aller droit au but. Si tu veux du détail, passe par les pages
          d’offres: elles ont des checklists et des graphiques.
        </p>

        <div className="mt-10 grid gap-3">
          {faqs.map((x) => (
            <details key={x.q} className="lbf-card group p-5">
              <summary className="cursor-pointer list-none text-sm font-extrabold text-white outline-none">
                <span className="inline-flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full bg-gradient-to-r from-fuchsia-400 to-indigo-300" />
                  {x.q}
                </span>
              </summary>
              <div className="mt-3 text-sm text-zinc-200/85">{x.a}</div>
            </details>
          ))}
        </div>

        <div className="mt-10 lbf-card p-6">
          <h2 className="text-xl font-black text-white">Note conformité</h2>
          <p className="mt-3 text-sm text-zinc-200/85">
            LuckyBetFR s’adresse à un public majeur (18+). Joue uniquement si tu peux te le permettre et si ça reste un
            divertissement, pas une solution.
          </p>
          <div className="mt-3 text-xs text-zinc-400">
            Page: <span className="font-semibold text-white/80">{site.domain}</span>
          </div>
        </div>
      </section>
    </>
  );
}


